import React, { useState, useEffect, memo } from 'react';
import "react-simple-keyboard/build/css/index.css";
import { authActions, kioskLoginActions } from '../_store';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/images/inmate-white-logo.png';
import CustomModal from '../components/common/CustomModal ';
import SecurityQuestionSchema from '../validation/SecurityQuestionSchema';
import CustomKeyboard from '../components/common/CustomKeyboard';
import Button from '../components/common/ui/Button';
import SelectInput from '../components/common/ui/Inputs/SelectInput';
import CustomInput from '../components/common/CustomInput';
import useKioskRestrictIntervalValidation from '../hooks/useKioskRestrictIntervalValidation';
import { getStoredValue, removeStoredValue } from "../_helpers/storageHelper";

const SecurityQuestion = () => {
    const { SecurityQuestions, loginResponse, ValidateSecurityQuestions, loginDetails } = useSelector(state => state.kioskLogin);
    const [errors, setErrors] = useState({});
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [securityQuestions, setSecurityQuestions] = useState({
        questionOne: '',
        questionTwo: '',
        questionThree: '',
        answerOne: '',
        answerTwo: '',
        answerThree: '',
        ishideanswer1: true,
        ishideanswer2: true,
        ishideanswer3: true
    });
    const [correctanswer, setcorrectanswer] = useState('');
    const [showPopup, setShowPopup] = useState(false);
    const [errorMessage, setErrorMessage] = useState({});
    const [currentField, setCurrentField] = useState('');
    const [values, setValues] = useState({});
    const [showBoard, setShowBoard] = useState(false);
    const [ishidePassword, setishidePassword] = React.useState(true);
    const allFields = ["questionOne", 'answerOne',"questiontwo", 'answerTwo', "questionthree", 'answerThree'];
    const keyboardFields = ['answerOne', 'answerTwo', 'answerThree'];
    const placeholder = {
        answerOne: "Answer here", answerTwo: "Answer here", answerThree: "Answer here",
    }
    const validateKioskRestrictInterval = useKioskRestrictIntervalValidation();
    const storedLoginDetails = getStoredValue("loginDetails") || loginDetails;
    const [prevcorrectanswer, setprevcorrectanswer] = useState();
    const [isActive, setIsActive] = useState(true);
    const [timeLeft, setTimeLeft] = useState(900); // Set to 10 seconds

    useEffect(() => {
            let inactivityTimer;
            const resetTimer = () => {
                setIsActive(true);
                setTimeLeft(900); // Reset timer to 10 seconds
                clearTimeout(inactivityTimer);
                // inactivityTimer = setTimeout(handleLogoutWarning, 5 * 1000); // Show warning after 5 seconds
            };
    
            window.addEventListener('mousemove', resetTimer);
            window.addEventListener('keydown', resetTimer);
            window.addEventListener('click', resetTimer);
    
            // inactivityTimer = setTimeout(handleLogoutWarning, 5 * 1000); // Show warning after 5 seconds
    
            return () => {
                clearTimeout(inactivityTimer);
                window.removeEventListener('mousemove', resetTimer);
                window.removeEventListener('keydown', resetTimer);
                window.removeEventListener('click', resetTimer);
            };
    
        }, []);
    
        useEffect(() => {
            if (!isActive || timeLeft <= 0) return;
    
            const countdownInterval = setInterval(() => {
                setTimeLeft(prevTime => {
                    if (prevTime <= 1) {
                        clearInterval(countdownInterval);
                        setIsActive(false);
                         dispatch(authActions.logout());
                        return 0;
                    }
                    return prevTime - 1;
                });
            }, 1000);
    
            return () => clearInterval(countdownInterval);
        }, [isActive, timeLeft]);
    

    useEffect(() => {
        if (loginResponse?.FacilityCode) {
            dispatch(kioskLoginActions.getLoadSecurityQuestionSet(loginResponse));
            if (loginResponse?.IsSQUpdated === 1)
                dispatch(kioskLoginActions.getLoadInmateValidateSecurity(loginResponse));
        }

    }, [loginResponse, dispatch]);

    useEffect(() => {
        // Function to execute on page refresh
        const handlePageRefresh = () => {
          removeStoredValue("inmateMenuList"); removeStoredValue("loginResponse"); removeStoredValue("KioskRestrictIntervalValidate");
          navigate('/');
        };
    
        // Check if the page has been refreshed
        if (sessionStorage.getItem('isRefreshed')) {
          handlePageRefresh();
        } else {
          sessionStorage.setItem('isRefreshed', 'true');
        }
    
        return () => {
           sessionStorage.removeItem('isRefreshed');
        };
      }, []);

    const validateForm = () => {
        const validationErrors = {};
        if (!correctanswer) validationErrors.correctanswer = 'Please enter your answer.';
        setErrors(validationErrors);
        return Object.keys(validationErrors).length === 0;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        validateKioskRestrictInterval(storedLoginDetails);
        if (loginResponse?.IsSQUpdated === 0) {
            setErrorMessage({});
            const { error } = SecurityQuestionSchema(securityQuestions);
            if (error) {
                error.details.forEach((e) => {
                    setErrorMessage((prev) => ({
                        ...prev,
                        [e.path.toString()]: e.message,
                    }));
                });
                return;
            }
            var submitObject = {
                inmateID: loginResponse?.InmateID,
                facilityID: loginResponse?.facilityID,
                questionAnswerList: [
                    { questionId: securityQuestions?.questionOne, sqAnswer: securityQuestions?.answerOne },
                    { questionId: securityQuestions?.questionTwo, sqAnswer: securityQuestions?.answerTwo },
                    { questionId: securityQuestions?.questionThree, sqAnswer: securityQuestions?.answerThree }
                ]
            };
            dispatch(kioskLoginActions.inmateSecurityQuestionInsertUpdate(submitObject));
            dispatch(kioskLoginActions.getLoadInmateValidateSecurity(loginResponse));
            navigate('/');
        }
        else {
            if (!validateForm()) return;
            if (ValidateSecurityQuestions[0]?.SQAnswer?.trim()?.toLowerCase() === correctanswer?.trim()?.toLowerCase()) {
                navigate('/Dashboard'); 
                setTimeout(() => {
                    window.location.reload();
                }, 100);
            }
            else {
                setShowPopup(true)
            }
        }
    };
    const handleclear = async () => {
        setErrorMessage({}); setErrors({});
        setSecurityQuestions({
            questionOne: '',
            questionTwo: '',
            questionThree: '',
            answerOne: '',
            answerTwo: '',
            answerThree: ''
        });
        setcorrectanswer('')
    }

    const handleKeyPress = (button) => {
        if (button === "{accept}" || button === "{enter}" || button === "{prev}" || button === "{next}" || button === "{cancel}") {
            setShowBoard(false);
        }
        else if (button === "{backspace}") {
            setcorrectanswer(correctanswer?.slice(0, -1));
        }
    };
    const handleKeyboardInputChange = (input) => {
        setcorrectanswer(input);
    };
    const handleFieldClick = (field) => {
        let data = securityQuestions ? securityQuestions : {
            questionOne: '',
            questionTwo: '',
            questionThree: '',
            answerOne: '',
            answerTwo: '',
            answerThree: '',
            ishideanswer1: true,
            ishideanswer2: true,
            ishideanswer3: true
        };
        setValues(data)
        setCurrentField(field);
        setShowBoard(true); // Show the keyboard when a field is clicked
    };

    const handleCancel = () => {
        if (values.questionOne || values.questionTwo || values.questionThree ||
            values.answerOne || values.answerTwo || values.answerThree) {
            setSecurityQuestions(values);
        } else {
            setSecurityQuestions({
                questionOne: '',
                questionTwo: '',
                questionThree: '',
                answerOne: '',
                answerTwo: '',
                answerThree: '',
                ishideanswer1: true,
                ishideanswer2: true,
                ishideanswer3: true
            });
        }
        setShowBoard(false)
    }

    const handleCanceled = () => {
        setcorrectanswer(prevcorrectanswer); setShowBoard(false);
    }

    return (
        <div className="parent-container">
            <div className="form-column">
                <img className='image' onClick={() => { navigate('/') }} src={logo} alt="Logo" />
                <div className="kiosk-setup-container">
                    <div>
                        <h2 className="securityTitle">Security Question</h2>
                        <form className="kiosk-setup-form" >
                            {(loginResponse?.IsSQUpdated === 0) ?
                                <>
                                    <div className="row" >
                                        <div className="col-md-6">
                                            <div className='mb-3'>
                                                <SelectInput
                                                    options={SecurityQuestions?.filter(x => (x?.QuestionID !== securityQuestions?.questionTwo &&
                                                        x?.QuestionID !== securityQuestions?.questionThree
                                                    ))}
                                                    label="Choose your Security Question 1"
                                                    name="questionOne"
                                                    required
                                                    id="questionOne"
                                                    width={100}
                                                    labelKey="SecurityQuestion"
                                                    valueKey="QuestionID"
                                                    value={securityQuestions?.questionOne}
                                                    placeholder="-- SELECT --"
                                                    handleChange={e => {
                                                        setSecurityQuestions(prevState => ({
                                                            ...prevState,
                                                            ["questionOne"]: e?.value
                                                        }));
                                                        // Clear the error message when a valid question is selected
                                                        if (e?.value) {
                                                            setErrorMessage(prevState => ({
                                                                ...prevState,
                                                                questionOne: ''
                                                            }));
                                                        }
                                                    }}
                                                    errorMessage={errorMessage}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <CustomInput
                                                    label={"Answer 1"}
                                                    type={securityQuestions?.ishideanswer1 ? "password" : "text"}
                                                    togglePasswordVisibility={() => {
                                                        setSecurityQuestions(prevFormData => ({
                                                            ...prevFormData,
                                                            ishideanswer1: !securityQuestions?.ishideanswer1
                                                        }))
                                                    }}
                                                    required={true}
                                                    placeholder={"Answer here"}
                                                    id="Answer"
                                                    value={securityQuestions?.answerOne}
                                                    onClick={() => { handleFieldClick('answerOne') }}
                                                    readOnly
                                                    errorMessage={errorMessage["answerOne"]}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row" >
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <SelectInput
                                                    options={SecurityQuestions?.filter(x => (x?.QuestionID !== securityQuestions?.questionOne &&
                                                        x?.QuestionID !== securityQuestions?.questionThree
                                                    ))}
                                                    label="Choose your Security Question 2"
                                                    name="questionTwo"
                                                    required
                                                    id="questionTwo"
                                                    width={100}
                                                    labelKey="SecurityQuestion"
                                                    valueKey="QuestionID"
                                                    value={securityQuestions?.questionTwo}
                                                    placeholder="-- SELECT --"
                                                    handleChange={e => {
                                                        setSecurityQuestions(prevState => ({
                                                            ...prevState,
                                                            ["questionTwo"]: e?.value
                                                        }));
                                                        // Clear the error message when a valid question is selected
                                                        if (e?.value) {
                                                            setErrorMessage(prevState => ({
                                                                ...prevState,
                                                                questionTwo: ''
                                                            }));
                                                        }
                                                    }}
                                                    errorMessage={errorMessage}
                                                />
                                            </div>

                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <CustomInput
                                                    label={"Answer 2"}
                                                    type={securityQuestions?.ishideanswer2 ? "password" : "text"}
                                                    togglePasswordVisibility={() => {
                                                        setSecurityQuestions(prevFormData => ({
                                                            ...prevFormData,
                                                            ishideanswer2: !securityQuestions?.ishideanswer2
                                                        }))
                                                    }}
                                                    required={true}
                                                    placeholder={"Answer here"}
                                                    id="Answer"
                                                    value={securityQuestions?.answerTwo}
                                                    onClick={() => { handleFieldClick('answerTwo') }}
                                                    readOnly
                                                    errorMessage={errorMessage["answerTwo"]}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row" >
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <SelectInput
                                                    options={SecurityQuestions?.filter(x => (x?.QuestionID !== securityQuestions?.questionTwo &&
                                                        x?.QuestionID !== securityQuestions?.questionOne
                                                    ))}
                                                    label="Choose your Security Question 3"
                                                    name="questionThree"
                                                    required
                                                    id="questionThree"
                                                    width={100}
                                                    labelKey="SecurityQuestion"
                                                    valueKey="QuestionID"
                                                    value={securityQuestions?.questionThree}
                                                    placeholder="-- SELECT --"
                                                    handleChange={e => {
                                                        setSecurityQuestions(prevState => ({
                                                            ...prevState,
                                                            ["questionThree"]: e?.value
                                                        }));
                                                        // Clear the error message when a valid question is selected
                                                        if (e?.value) {
                                                            setErrorMessage(prevState => ({
                                                                ...prevState,
                                                                questionThree: ''
                                                            }));
                                                        }
                                                    }}
                                                    errorMessage={errorMessage}
                                                />
                                            </div>

                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <CustomInput
                                                    label={"Answer 3"}
                                                    type={securityQuestions?.ishideanswer3 ? "password" : "text"}
                                                    togglePasswordVisibility={() => {
                                                        setSecurityQuestions(prevFormData => ({
                                                            ...prevFormData,
                                                            ishideanswer3: !securityQuestions?.ishideanswer3
                                                        }))
                                                    }}
                                                    required={true}
                                                    placeholder={"Answer here"}
                                                    id="Answer"
                                                    value={securityQuestions?.answerThree}
                                                    onClick={() => { handleFieldClick('answerThree') }}
                                                    readOnly
                                                    errorMessage={errorMessage["answerThree"]}
                                                />
                                            </div>

                                        </div>
                                        <div className="col-md-12">
                                            <div className="questionNote font-size-13 mb-3" style={{ marginTop: '10px' }}>

                                                <b className='text-default-red'>Note:</b><span className='text-italian' > To improve your account's safety. Please choose any of these 3 questions and you will be prompted to answer these upon your next login.
                                                </span>
                                            </div>
                                        </div>
                                    </div></> :
                                <div className="form-row">
                                    <div className="col-md-12">
                                        <label className='span-question text-default-red'>Question : </label><span className='span-question'> {ValidateSecurityQuestions && ValidateSecurityQuestions[0]?.SecurityQuestion}</span>
                                        <CustomInput
                                            // label={ValidateSecurityQuestions && ValidateSecurityQuestions[0]?.SecurityQuestion}
                                            type={ishidePassword ? "password" : "text"}
                                            required={true}
                                            placeholder={"Enter Your Answer"}
                                            id="correctanswer"
                                            value={correctanswer}
                                            togglePasswordVisibility={() => { setishidePassword(!ishidePassword) }}
                                            onClick={() => { setShowBoard(true); setprevcorrectanswer(correctanswer) }}
                                            errorMessage={errors.correctanswer}
                                        />
                                    </div>
                                    <div className="col-md-12">
                                        <div className="questionNote font-size-13 mb-3">

                                            <b className='text-default-red'>Note:</b><span className='text-italian'>You will have to answer the response you entered earlier. Answers are not case sensitive.
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            }
                            {showBoard && (
                                loginResponse?.IsSQUpdated === 0 ? (
                                    <CustomKeyboard
                                        currentField={currentField}
                                        setCurrentField={setCurrentField}
                                        inputs={securityQuestions}
                                        setShowBoard={setShowBoard}
                                        handleCancel={handleCancel}
                                        setInputs={setSecurityQuestions}
                                        fields={keyboardFields}
                                        setErrorMessage={setErrorMessage}
                                        type="Multiple"
                                        setValues={setValues}
                                        placeholderList={placeholder}
                                        isPassword={true}
                                        allFields={allFields}
                                        fromKioskSetup={true}
                                        isSuggestionsEnabled={false}
                                    />
                                ) : (
                                    <CustomKeyboard
                                        onInputChange={handleKeyboardInputChange}
                                        inputValue={correctanswer}
                                        onKeyPress={handleKeyPress}
                                        placeholder={"Enter Your Answer"}
                                        isPassword={true}
                                        handleCancel={handleCanceled}
                                        setShowBoard={setShowBoard}
                                        fromKioskSetup={true}
                                        isSuggestionsEnabled={false}
                                    />
                                )
                            )}

                            <div className="actions mt-30">
                                <Button label="SUBMIT" status="primary" type="submit" onClick={handleSubmit} />
                                <Button label="RESET" className="btn btn-warning" type="button" onClick={() => { handleclear() }} />
                            </div>
                        </form>
                    </div>
                    {showPopup && <CustomModal content="Answer doesn't match" color={'#c8605e'} onOkClick={() => { setShowPopup(false); navigate('/'); }} />}
                </div>
            </div>
        </div>
    );
};
export default memo(SecurityQuestion);